import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-all-expenditure',
  templateUrl: './all-expenditure.component.html',
  styleUrls: ['./all-expenditure.component.scss']
})
export class AllExpenditureComponent implements OnInit, OnDestroy {

  expenditureData: any = []
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  pageNo:number = 1
  constructor(private navservice:NavigationService,private _apiservice:ApiService, private loaderservice: LoaderServiceService) {this.navservice.hideSidebarAndNav=false 
    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_LATEST_EXPENSES_FOR_DASHBOARD){
        this.expenditureData = []
        if(resdata.result){
          this.expenditureData = resdata.result
          this.expenditureData.forEach((element:any) => {
            element.expense_datetime = element.expense_datetime.slice(0,10)
            element.time = this.formatToAmPm(element.expense_datetime)
            element.price = (element.currency_symbol ? element.currency_symbol : '₹') + element.amount.toFixed(2)
          });
        }
        this.loaderservice.showLoader = false
        this.loader = false
      }
    })
  }

  ngOnInit(): void {
    this.loaderservice.showLoader = true
    this.loader = true
    this._apiservice.getLatestExpensesForDashboard('500',this.pageNo)
  }

  // tableDisplayColumns: string[] = ['image', 'name', 'shop', 'payment', 'time', 'assigned', 'status'];
  
  bookingData = [
    { image: '../assets/images/e-purchase.png', name: 'Employee salary', notes: 'Aniket For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '3:00 PM',  amount:'₹23190' },
    { image: '../assets/images/e-salary.png', name: 'Chair purchase', notes: 'Aniket For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '5:00 PM',  amount:'₹2290' },
    { image: '../assets/images/e-purchase.png', name: 'Sunscreens purchase', notes: 'Aniket For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '12:00 PM',  amount:'₹30190' },
    { image: '../assets/images/others.png', name: 'Others', notes: 'Aniket For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '9:00 PM',  amount:'₹590' },
    { image: '../assets/images/others.png', name: 'Others', notes: 'Raktim For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '12:00 PM',  amount:'₹990' },
    { image: '../assets/images/e-purchase.png', name: 'Employee salary', notes: 'Aniket For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '4:00 PM',  amount:'₹90' },
    { image: '../assets/images/others.png', name: 'Others', notes: 'Aniket For 2024-06-14 To', shop: 'Mithali Hair, Spa',  location: 'Bengal Ambuja Durgapur, West Bengal 713216', date: '2024-07-12', time: '7:00 PM',  amount:'₹23190' },
  
  ];


  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "expense_label"
    },
    {
      columnName: "notes",
      columnProperty: "expense_detail"
    },
    {
      columnName: "shop",
      columnProperty: "name"
    },
    {
      columnName: "location",
      columnProperty: "address_line"
    },
    {
      columnName: "date",
      columnProperty: "expense_datetime"
    },
    {
      columnName: "time",
      columnProperty: "time"
    },
    {
      columnName: "amount",
      columnProperty: "price"
    }
  ];

  formatToAmPm(dateString:any) {
    const date = new Date(dateString);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // Hour '0' should be '12'
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;

    return `${hours}:${minutesStr} ${ampm}`;
}

ngOnDestroy(): void {
  this._apisub.unsubscribe()
}

}
